export const PROMO_IPHONE_18_IMAGES_URL = 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/iphone-18'

export type PromoImage = {
	src: string
	link?: string
	alt?: string
}

export type PromoImageSources = Record<'desktop' | 'mobile' | 'tablet', PromoImage>
